<div class="footer-inner" [class.footer-result]="footerService.isResult()">
  @if (!footerService.isResult()) {
    <div class="media-buttons">
      <qai-call-button
        [label]="'call.CAPTIONS_LABEL' | transloco"
        [kind]="footerService.captionsOn() ? 'tertiary' : 'destructive'"
        [icon]="footerService.captionsOn() ? 'captions' : 'captions-off'"
        (clicked)="onCaptionsClick()"
      />
      <qai-call-button
        [label]="'call.AUDIO' | transloco"
        [kind]="footerService.isMicOn() ? 'tertiary' : 'destructive'"
        [icon]="footerService.isMicOn() ? 'microphone' : 'microphone-off'"
        (clicked)="onMicrophoneClick()"
      />
      @if (footerService.isActive()) {
        <qai-call-button
          [label]="'call.VIDEO_LABEL' | transloco"
          [kind]="footerService.isVideoOn() ? 'tertiary' : 'destructive'"
          [icon]="footerService.isVideoOn() ? 'video-recorder' : 'video-recorder-off'"
          (clicked)="onVideoClick()"
        />
      }
    </div>
  }

  <button
    qai-button
    [kind]="footerService.actionKind()"
    size="large"
    [disabled]="footerService.isActionDisabled()"
    (click)="onActionClick()"
  >
    @if (footerService.isActive()) {
      <qai-icon kind="phone-call" positionStart />
    }
    {{ footerService.actionLabel() | transloco }}
  </button>
</div>
